export const ISideNavItems = [
  {
    name: 'Management Info',
    icon: 'icons/menu-head-icons/ManagementInfo.png',
    submenu: [
      { name: 'General', path: 'general', icon: 'icons/reviews_icon.png' },
      {
        name: 'Operations',
        path: 'operations',
        icon: 'icons/booking_icon.png',
      },
      { name: 'Finance', path: 'finance', icon: 'icons/dashboard_icon.png' },
    ],
  },
  {
    name: 'Accounting',
    icon: 'icons/menu-head-icons/Accounting.png',
    submenu: [
      {
        name: 'Account',
        path: 'accounting/account',
        icon: 'icons/reviews_icon.png',
      },
      {
        name: 'Invoice',
        path: 'accounting/invoice',
        icon: 'icons/booking_icon.png',
      },
      {
        name: 'Payments',
        path: 'accounting/payments',
        icon: 'icons/dashboard_icon.png',
      },
    ],
  },
  {
    name: 'Relaties',
    icon: 'icons/menu-head-icons/Relaties.png',
    submenu: [
      {
        name: 'Vakmanenen',
        path: 'vakmanenen',
        icon: 'icons/reviews_icon.png',
      },
      { name: 'Klaten', path: 'klaten', icon: 'icons/booking_icon.png' },
      { name: 'Patners', path: 'patners', icon: 'icons/dashboard_icon.png' },
    ],
  },
  {
    name: 'Boekingen',
    icon: 'icons/menu-head-icons/Boekingen.png',
    submenu: [
      {
        name: 'All boekingen',
        path: 'booking/all-boekingen',
        icon: 'icons/reviews_icon.png',
      },
      {
        name: 'Openstannde boekingen',
        path: 'booking/open-booking/:id',
        icon: 'icons/booking_icon.png',
      },
      {
        name: 'In te plannen bookingen',
        path: 'inteplannenboekingen',
        icon: 'icons/dashboard_icon.png',
      },
    ],
  },
  {
    name: 'Finance',
    icon: 'icons/menu-head-icons/Finance.png',
    submenu: [
      { name: 'Offerters', path: 'offerters', icon: 'icons/reviews_icon.png' },
      {
        name: 'All boekingen',
        path: 'allboekingen',
        icon: 'icons/booking_icon.png',
      },
      {
        name: 'Not te factureren boekingen',
        path: 'notefacturerenboekingen',
        icon: 'icons/dashboard_icon.png',
      },
      {
        name: 'Gefactureeden bookingen',
        path: 'gefactureedenboekingen',
        icon: 'icons/dashboard_icon.png',
      },
      {
        name: 'Gedeclareerd',
        path: 'gedeclareerd',
        icon: 'icons/dashboard_icon.png',
      },
      {
        name: 'Uibetalingen vakman',
        path: 'uibetalingen',
        icon: 'icons/dashboard_icon.png',
      },
      { name: 'Incasso', path: 'incasso', icon: 'icons/dashboard_icon.png' },
      {
        name: 'Exact Online',
        path: 'exactonline',
        icon: 'icons/dashboard_icon.png',
      },
      { name: 'Stripe', path: 'tripe', icon: 'icons/dashboard_icon.png' },
      { name: 'Exports', path: 'exports', icon: 'icons/dashboard_icon.png' },
    ],
  },
  {
    name: 'CMS',
    icon: 'icons/menu-head-icons/CMS.png',
    submenu: [
      { name: 'Paginas', path: 'paginas', icon: 'icons/reviews_icon.png' },
      {
        name: 'Categorien',
        path: 'categorien',
        icon: 'icons/booking_icon.png',
      },
      {
        name: 'Product regels',
        path: 'productregels',
        icon: 'icons/dashboard_icon.png',
      },
      {
        name: 'Agolia vertal engine',
        path: 'agoliavertalengine',
        icon: 'icons/dashboard_icon.png',
      },
    ],
  },
  {
    name: 'IT',
    icon: 'icons/menu-head-icons/Accounting.png',
    submenu: [
      {
        name: 'Clients',
        path: 'itdepartment/clients',
        icon: 'icons/reviews_icon.png',
      },
    ],
  },
];
